import { css } from '@emotion/css'

import { shorthandHelper, mediaQueryHelper } from '../../styles/helpers'
import { breakpoint, spacing } from '../../styles'

const styles = {
  wrapper: css({
    boxSizing: 'border-box',
    margin: 'auto',
    padding: shorthandHelper([0, spacing.default]),
    width: '100%',

    [mediaQueryHelper(breakpoint.tablet)]: {
      padding: shorthandHelper([0, spacing.medium]),
    },

    [mediaQueryHelper(breakpoint.desktop)]: {
      width: breakpoint.desktop,
    },
  }),
}

export default styles
